export function setInfo(text: string, isDesktop = false) {
  const el = document.getElementById('info-text');
  const info = document.getElementById('info');
  if (el) el.textContent = text;
  if (info) info.classList.toggle('desktop-info', !!isDesktop);
}

export function setInfoOverlayVisibility(visible: boolean) {
  const info = document.getElementById('info');
  if (info) info.style.display = visible ? 'block' : 'none';
}
